import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-analysis",
  "use": "icon-analysis-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-analysis\"><defs><style type=\"text/css\"></style></defs><path d=\"M72 944.8h241.6V361H72v583.8z m40.3-543.5h161v503.3h-161V401.3z m624-281.8h161v627.4l40.3 43.9V79.2H696v352.3h40.3v-312z m-312 140.9h161v171.1h40.3V220.1H384v724.7h241.8v-40.3H424.3V260.4zM940.2 870l-56.9-56.9c-10.5-10.5-25.3-13.8-38.8-10.3l-33.3-33.3c57-71.1 52.5-175.2-13.4-241.1-70.8-70.8-185.5-70.8-256.2 0-70.8 70.8-70.8 185.5 0 256.2 65.9 65.9 170 70.4 241.1 13.4l33.3 33.3c-3.5 13.4-0.2 28.2 10.3 38.8l56.9 56.9c15.7 15.7 41.2 15.7 56.9 0 15.8-15.8 15.8-41.3 0.1-57zM769.4 756.1c-55 55-144.3 55-199.3 0s-55-144.3 0-199.3 144.3-55 199.3 0c55 55.1 55 144.3 0 199.3z m-73.2 148.4v40.3H817l-30.2-40.3h-90.6z\" p-id=\"2637\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/analysis.svg
// module id = /tUJ
// module chunks = 52